import { FC, HTMLAttributes } from 'react'
import clsx from 'classnames'
import { ArrowXAxisIcon } from '@/shared/icons/arrow-x-axis-icon'
import { usePagination, DOTS } from './funcs'
import style from './pagination.module.scss'

interface PaginationProps extends HTMLAttributes<HTMLDivElement> {
  totalPageCount: number
  pageSize: number
  siblings?: number
  currentPage: number
  onPageChange: (page: number) => void
}

export const Pagination: FC<PaginationProps> = ({
  onPageChange,
  totalPageCount,
  siblings = 1,
  currentPage,
  pageSize,
  className,
}) => {
  const paginationRange =
    usePagination({
      currentPage,
      totalPageCount,
      siblings,
      pageSize,
    }) || []

  if (currentPage === 0 || paginationRange.length < 2) {
    return null
  }

  const onNext = () => {
    onPageChange(currentPage + 1)
  }

  const onPrevious = () => {
    onPageChange(currentPage - 1)
  }

  let lastPage = paginationRange[paginationRange.length - 1]
  return (
    <nav className={clsx(style.wrapper, className)}>
      <ul className={clsx(style.container, 'text text_type_d')}>
        <ArrowXAxisIcon
          direction="prev"
          onClick={onPrevious}
          className={clsx(style.arrow, 'arrow-icon', {
            [style.disabled]: currentPage === 1,
          })}
        />
        {paginationRange.map(pageNumber => {
          if (pageNumber === DOTS) {
            return (
              <li key={pageNumber} className={style.dots}>
                &#8230;
              </li>
            )
          }

          return (
            <li
              key={pageNumber}
              className={clsx(style.paginationItem, {
                [style.selected]: pageNumber === currentPage,
              })}
              onClick={() => onPageChange(Number(pageNumber))}
            >
              {pageNumber}
            </li>
          )
        })}
        <ArrowXAxisIcon
          direction="next"
          onClick={onNext}
          className={clsx(style.arrow, 'arrow-icon', {
            [style.disabled]: currentPage === lastPage,
          })}
        />
      </ul>
    </nav>
  )
}
